import { Navbar as _Navbar, NavbarProps as _NavbarProps } from "reactstrap";

export const Navbar = _Navbar;
export type NavbarProps = _NavbarProps;
